import './training-filter';
import './postcode-check';

(function($) {

	var objectFitImages = require('object-fit-images');
	var SVGInjector = require('svg-injector');


	objectFitImages('img.img--objectfit');


	var mySVGsToInject = document.querySelectorAll('img.inject');
    new SVGInjector(mySVGsToInject);


	// Plus en minus bij product input
	function wcqib_refresh_quantity_increments() {
	    jQuery("div.quantity:not(.buttons_added), td.quantity:not(.buttons_added)").each(function(a, b) {
	        var c = jQuery(b);
	        c.addClass("buttons_added"), c.children().first().before('<input type="button" value="-" class="minus" />'), c.children().last().after('<input type="button" value="+" class="plus" />')
	    })
	}
	String.prototype.getDecimals || (String.prototype.getDecimals = function() {
	    var a = this,
	        b = ("" + a).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
	    return b ? Math.max(0, (b[1] ? b[1].length : 0) - (b[2] ? +b[2] : 0)) : 0
	}), jQuery(document).ready(function() {
	    wcqib_refresh_quantity_increments()
	}), jQuery(document).on("updated_wc_div", function() {
	    wcqib_refresh_quantity_increments()
	}), jQuery(document).on("click", ".plus, .minus", function() {
	    var a = jQuery(this).closest(".quantity").find(".qty"),
	        b = parseFloat(a.val()),
	        c = parseFloat(a.attr("max")),
	        d = parseFloat(a.attr("min")),
	        e = a.attr("step");
	    b && "" !== b && "NaN" !== b || (b = 0), "" !== c && "NaN" !== c || (c = ""), "" !== d && "NaN" !== d || (d = 0), "any" !== e && "" !== e && void 0 !== e && "NaN" !== parseFloat(e) || (e = 1), jQuery(this).is(".plus") ? c && b >= c ? a.val(c) : a.val((b + parseFloat(e)).toFixed(e.getDecimals())) : d && b <= d ? a.val(d) : b > 0 && a.val((b - parseFloat(e)).toFixed(e.getDecimals())), a.trigger("change")
	});
	// Einde plus en minus bij product input


	// Selectpicker
	// $(document).bind('gform_post_render', function(){
	//     $('.gform_wrapper .gfield_select').addClass('selectpicker');

	//     $('.selectpicker').selectpicker({
	//         width: '100%',
	//         style: null
	//     });
	// });
	$('.field_type_selectbox select').addClass('selectpicker');

	// $('.selectpicker').selectpicker({
	// 	width: '100%',
	// 	style: null
	// });
	// Einde selectpicker


	// Catalogus formulier
	$("#form-catalogus").change(function() {
		$.ajax({
	       	method: 'post',
	       	url: WPURLS.ajaxurl,
	       	data: {
	           	'action': 'formcontent',
	           	'data': $(this).serialize()
	       	},
	       	success: function( data ) {
	           $('.order__orders').html(data);
	           checkemptycart();
	       	}
	   });
	});

	$(".order__orders").on('click', '.order-item__delete', function(e){
		e.preventDefault();

		var $item = $(this).parents('.order-item');
		var idItem = $item.attr('data-id');
		var $input = $('[name="'+idItem+'"]');


		$input.val(0);

		$item.remove();

		checkemptycart();

		$.ajax({
	       	method: 'post',
	       	url: WPURLS.ajaxurl,
	       	data: {
	           	'action': 'removefromcart',
	           	'id': idItem
	       	},
	       	success: function( data ) {

	       	}
	   	});
	});

	function checkemptycart(){
		if( !$(".order-item").length ){
			$('.order__inner').addClass('order__inner--disabled');
		}
		else{
			$('.order__inner').removeClass('order__inner--disabled');
		}
	}

	// Einde catalogus formulier



	// var $datepicker = $('.datepicker');

	// if( $datepicker.length ){
	//     $('.datepicker').datepicker({
	//         dayNamesMin: [ "Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za" ],
	//         monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec" ],
	//         monthNames: [ "Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December" ],
	//         firstDay: 1,
	//         minDate: "+1d",
	//         dateFormat: 'dd-mm-yy'
	//     });
	// };

	$('.community-story--video').magnificPopup({
		type: 'iframe'
	});
	$('[data-form-type="disabled"]').each(function() {
		var $el = $(this),
			$submit = $el.find('[type="submit"]'),
			$required = $el.find(':required');

		$el
		.on('change keyup', function(e) {
			var $filtered = $required.filter(function(index) {
				var $field = $(this);

				// TODO: ook voor andere types checken
				if($field.is('[type=checkbox]')) {
					return $field.prop('checked');
				} else {
					return $field.val();
				}
			});

			var $equalTo = $el.find('[data-equal-to]'),
				allEqual = true;

			if($equalTo.length) {
				var $equal = $equalTo.filter(function() {
					var $field = $(this),
						$target = $($field.attr('data-equal-to'));

					if($field.val() == $target.val()) {
						return true;
					}
				});

				if($equal.length == $equalTo.length) {
					allEqual = true;
				} else {
					allEqual = false;
				}
			}

			if($required.length == $filtered.length && allEqual) {
				$submit.prop('disabled', false);
			} else {
				$submit.prop('disabled', true);
			}
		})
		.on('submit', function(e) {
			$submit
			.text('Even geduld...')
			.prop('disabled', true);
		})
		.trigger('change');
	});

	$('#register-training-form').on('click', '.fnv-button-wrapper', function(e) {
		var $el = $(this),
			$button = $el.find('[type="submit"]'),
			$checkbox = $('#career_dialog_mandatory');

		if($button.prop('disabled') && !$checkbox.is(':checked')) {
			$('#needs-check-modal').addClass('active');
		}
	});



	// Add Call to Action to Register Form
	var add_cta_to_register_form = function() {
		var $memberField = $('.field_lidnummer');
		if ($memberField) {
			$('.field_lidnummer').find('.description').append('<a href="https://www.fnv.nl/lidmaatschap/lid-worden/" target="_blank" class="fnv-button fnv-button--green">Lid worden ></div>');
		}

	}
	add_cta_to_register_form();


	$(document).on('click', '#registration-modal-close', function(evt) {
		evt.preventDefault();
		$(this).parents('.registration_complete__modal--wrapper').removeClass('active');
	});


	$(document).on('click', '.filter__collapse--header', function(evt) {
		evt.preventDefault();
		$('body').toggleClass('body--filter-open');
	});



	$.datepicker._defaults.onAfterUpdate = null;
	var datepicker__updateDatepicker = $.datepicker._updateDatepicker;
	$.datepicker._updateDatepicker = function (inst) {
		datepicker__updateDatepicker.call(this, inst);
		var onAfterUpdate = this._get(inst, 'onAfterUpdate');
		if (onAfterUpdate)
			onAfterUpdate.apply((inst.input ? inst.input[0] : null),
				[(inst.input ? inst.input.val() : ''), inst]);
	}
	var cur = -1, prv = -1;
	$('#daterange div')
		.datepicker({
			changeMonth: false,
			changeYear: false,
			showButtonPanel: false,
			dateFormat: 'dd/mm/yy',
			beforeShowDay: function (date) {
				return [true, ((date.getTime() >= Math.min(prv, cur) && date.getTime() <= Math.max(prv, cur)) ? 'date-range-selected' : '')];
			},
			onSelect: function (dateText, inst) {
				var d1, d2;
				prv = cur;
				cur = (new Date(inst.selectedYear, inst.selectedMonth, inst.selectedDay)).getTime();

				var dateRange = [];

				if (prv == -1 || prv == cur) {
					prv = cur;
					$('#daterange input').val(dateText);
				} else {
					d1 = $.datepicker.formatDate('dd/mm/yy', new Date(Math.min(prv, cur)), {});
					d2 = $.datepicker.formatDate('dd/mm/yy', new Date(Math.max(prv, cur)), {});
					$('#daterange input').val(d1 + ' - ' + d2);
				}

				$('#daterange input').trigger('change');
			},
			onChangeMonthYear: function (year, month, inst) {
				//prv = cur = -1;
			},
			onAfterUpdate: function (inst) {
			}
		})
		.hide();

		$('#daterange input').on('focus', function (e) {
			var v = this.value,
				d;
			try {
				if (v.indexOf(' - ') > -1) {
					d = v.split(' - ');
					prv = $.datepicker.parseDate('dd/mm/yy', d[0]).getTime();
					cur = $.datepicker.parseDate('dd/mm/yy', d[1]).getTime();
				} else if (v.length > 0) {
					prv = cur = $.datepicker.parseDate('dd/mm/yy', v).getTime();
				}
			} catch (e) {
				cur = prv = -1;
			}
			if (cur > -1)
				$('#daterange div').datepicker('setDate', new Date(cur));
			$('#daterange div').datepicker('refresh').show();
		});

		$(document).on('click', function(evt) {
			$('#daterange div').hide();
		});

		$('#daterange').click(function (evt) {
			evt.stopPropagation();
		});




})(jQuery);